import { Command } from 'commander';
import { GeneratePusherCommand } from './generatePusherCommand';
import { StepCommands } from '../StepCommands';

export function PusherCommand(): Command {
  const cmd = new Command('pusher');
  cmd.alias('ps').description('Pusher related commands.');
  cmd.addCommand(GeneratePusherCommand());
  cmd.addCommand(StepCommands('pusher'));
  return cmd;
}
